const SINGLES = [
  '.s-trades__head',
  '.s-counter__copy',
  '.s-counter__collage',
  '.s-weekend__copy',
  '.s-weekend__visual',
  '.s-house__copy',
  '.s-house__visual',
  '.s-commitments__head',
  '.s-reviews__head',
  '.s-reviews__slider',
  '.s-families__intro',
  '.s-portrait__copy',
  '.s-portrait__photo',
  '.s-team__intro',
  '.s-timeline__intro',
  '.s-timeline__step',
  '.s-principles__intro',
  '.s-principles__item',
  '.s-orders__intro',
  '.s-orders__item',
  '.s-labels__head',
  '.s-labels__item',
  '.s-advice__copy',
  '.s-advice__actions',
  '.s-hours__copy',
  '.s-hours__table > li',
  '.s-access__card',
  '.s-access__map',
  '.s-write__intro',
  '.s-write__form',
  '.s-article-body__aside',
  '.s-article-body__section',
  '.s-visit__panel',
  '.s-commitments__item',
]

const ROWS = [
  ['.s-trades__list', ':scope > .s-trades__card'],
  ['.s-trades__slider', '.swiper-slide'],
  ['.s-families__grid', ':scope > li'],
  ['.s-team__grid', ':scope > li'],
]

export class Reveal {
  constructor() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return
        }

        const items = entry.target._revealItems

        if (items) {
          items.forEach((item) => item.classList.add('is-in'))
        } else {
          entry.target.classList.add('is-in')
        }

        io.unobserve(entry.target)
      })
    }, {
      rootMargin: '0px 0px -25% 0px',
      threshold: 0,
    })

    document.querySelectorAll(SINGLES.join(',')).forEach((el) => io.observe(el))

    ROWS.forEach(([parent, child]) => {
      document.querySelectorAll(parent).forEach((group) => {
        const items = group.querySelectorAll(child)

        if (!items.length) {
          return
        }

        group._revealItems = items
        io.observe(group)
      })
    })
  }
}
